import styled from 'styled-components'
import OrderStatus from './components/OrderStatus'
import OrderStatusMobile from './components/mobile/OrderStatusMobile'
import { Container, Main } from './styles/main'
import { TrackerRootProps } from './types'

const OrderStatusContainerDesktop = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 801px) {
    width: 100%;
    height: 500px;
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

const OrderStatusContainerMobile = styled.div`
  @media only screen and (min-width: 801px) {
    display: none;
  }

  @media only screen and (max-width: 800px) {
    width: 100%;
    height: 500px;
  }
`

const TrackerRoot = ({ className, orderId }: TrackerRootProps) => {
  return (
    <Container className={className}>
      <Main>
        <OrderStatusContainerDesktop>
          <OrderStatus orderId={orderId} />
        </OrderStatusContainerDesktop>
        <OrderStatusContainerMobile>
          <OrderStatusMobile orderId={orderId} />
        </OrderStatusContainerMobile>
      </Main>
    </Container>
  )
}

export default TrackerRoot
